<template>
  <div>
    <login></login>
  </div>
</template>

<script>
import Login from './../../components/security/login';
export default {
  data: () => ({}),
  components: {
    Login
  }
}
</script>